"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author Vahagn.Lazyan
 * @since 9/15/2017
 */
var core_1 = require("@angular/core");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var token_expiration_service_1 = require("../token-expiration-manager/token-expiration.service");
var login_status_enum_1 = require("../../../provider/enums/login-status.enum");
var common_1 = require("@angular/common");
var ExpiredTokenPopupComponent = /** @class */ (function () {
    function ExpiredTokenPopupComponent(tokenExpirationService, authenticationService, cookieService, platformLocation) {
        this.tokenExpirationService = tokenExpirationService;
        this.authenticationService = authenticationService;
        this.cookieService = cookieService;
        this.platformLocation = platformLocation;
        this.showTwoFactorAuthentication = false;
        this.isUserBlocked = false;
        this.verificationType = idm_authentication_client_js_1.VerificationType.EMAIL;
        this._close = new core_1.EventEmitter();
        this._userData = new idm_authentication_client_js_1.UserData();
        this._openSubscriptions = [];
        this._validationMessage = null;
    }
    ExpiredTokenPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.cookieService.delete('csrfToken');
        this._openSubscriptions.push(this.authenticationService.getUserData().subscribe(function (userData) {
            _this._userData = userData;
            _this._isSAMLUser = _this.cookieService.get(idm_authentication_client_js_1.AuthSettings.IS_SAML_USER) === 'true';
        }, console.error));
    };
    ExpiredTokenPopupComponent.prototype.login = function () {
        var _this = this;
        this.tokenExpirationService.loginByPassword(this.passwordInputElement.nativeElement.value).then(function () {
            _this.passwordInputElement.nativeElement.value = null;
            _this._validationMessage = null;
            _this._close.emit();
            _this.tokenExpirationService.tokenUpdatedViaQuickLogin(true);
        }, function (loginObject) {
            switch (loginObject.loginStatus) {
                case login_status_enum_1.LoginStatus.EXPIRED:
                case login_status_enum_1.LoginStatus.BLOCKED:
                    _this.isUserBlocked = true;
                    _this.toBeUnblockedDate = loginObject.data;
                    _this.validationMessage = loginObject.message;
                    break;
                case login_status_enum_1.LoginStatus.FAILED:
                    _this._validationMessage = loginObject.message;
                    break;
                case login_status_enum_1.LoginStatus.NEED_VERIFICATION:
                    _this.verificationType = loginObject.message;
                    _this.showTwoFactorAuthentication = true;
                    break;
                default:
                    console.error(loginObject);
                    throw new Error('No such login response type ' + loginObject.loginResponseType);
            }
        });
    };
    ExpiredTokenPopupComponent.prototype.onSSOLogin = function () {
        var _this = this;
        this.tokenExpirationService.loginViaSAML().then(function (openedWin) {
            var timer = setInterval(function () {
                if (openedWin.closed) {
                    _this._close.emit();
                    _this.tokenExpirationService.tokenUpdatedViaQuickLogin(true);
                    clearInterval(timer);
                }
            }, 1000);
        });
    };
    ExpiredTokenPopupComponent.prototype.logout = function () {
        this.tokenExpirationService.logout();
        this.tokenExpirationService.tokenUpdatedViaQuickLogin(false);
        this._close.emit();
    };
    ExpiredTokenPopupComponent.prototype.ngOnDestroy = function () {
        this._openSubscriptions.forEach(function (subscription) {
            subscription.unsubscribe();
        });
    };
    Object.defineProperty(ExpiredTokenPopupComponent.prototype, "close", {
        get: function () {
            return this._close;
        },
        set: function (value) {
            this._close = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExpiredTokenPopupComponent.prototype, "userData", {
        get: function () {
            return this._userData;
        },
        set: function (value) {
            this._userData = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExpiredTokenPopupComponent.prototype, "validationMessage", {
        get: function () {
            return this._validationMessage;
        },
        set: function (value) {
            this._validationMessage = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ExpiredTokenPopupComponent.prototype, "isSAMLUser", {
        get: function () {
            return this._isSAMLUser;
        },
        set: function (value) {
            this._isSAMLUser = value;
        },
        enumerable: true,
        configurable: true
    });
    ExpiredTokenPopupComponent.prototype.resetUserBlockedFlag = function () {
        this.isUserBlocked = false;
        this.validationMessage = undefined;
    };
    __decorate([
        core_1.ViewChild('password'),
        __metadata("design:type", core_1.ElementRef)
    ], ExpiredTokenPopupComponent.prototype, "passwordInputElement", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter),
        __metadata("design:paramtypes", [core_1.EventEmitter])
    ], ExpiredTokenPopupComponent.prototype, "close", null);
    ExpiredTokenPopupComponent = __decorate([
        core_1.Component({
            
            selector: 'sis-expired-token-popup',
            template: require('./expired-token-popup.component.html'),
            styles: [require('./expired-token-popup.component.css')]
        }),
        __metadata("design:paramtypes", [token_expiration_service_1.TokenExpirationService,
            idm_authentication_client_js_1.AuthenticationService,
            idm_authentication_client_js_1.CookieService,
            common_1.PlatformLocation])
    ], ExpiredTokenPopupComponent);
    return ExpiredTokenPopupComponent;
}());
exports.ExpiredTokenPopupComponent = ExpiredTokenPopupComponent;
//# sourceMappingURL=expired-token-popup.component.js.map